// storageUtils.js

export function setCookie(name, value, minutes) {
  const encodedValue = btoa(value);
  let expires = '';
  if (minutes) {
    const date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + encodedValue + expires + '; path=/; Secure';
}

export function getCookie(name) {
  const decodedValue =
    decodeURIComponent(
      atob(
        document.cookie.replace(
          new RegExp(
            '(?:(?:^|.*;)\\s*' +
              encodeURIComponent(name).replace(/[-.+*]/g, '\\$&') +
              '\\s*\\=\\s*([^;]*).*$)|^.*$'
          ),
          '$1'
        )
      )
    ) || null;
  return decodedValue;
}

export function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export function deleteCookies(cookies) {
  if (!Array.isArray(cookies)) {
    console.error('Parameter should be an array of cookie names.');
    return;
  }

  cookies.forEach((cookieName) => {
    document.cookie =
      cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  });
}

export function setPlainCookie(name, value, seconds) {
  let cookie = `${name}=${encodeURIComponent(value)}; path=/`;

  if (typeof seconds === 'number') {
    const expires = new Date(Date.now() + seconds * 1000).toUTCString();
    cookie += `; expires=${expires}`;
  }

  document.cookie = cookie;
}

/**
   * @description Get a cookie value by name.
   * @param {string} name - The cookie name.
   * @returns {string|null} The cookie value if found, otherwise null.
   */
export function getPlainCookie(name) {
  const nameEQ = encodeURIComponent(name) + "=";
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
      const c = cookie.trim();
      if (c.startsWith(nameEQ)) {
          return decodeURIComponent(c.substring(nameEQ.length));
      }
  }

  return null;
};
